export class ProfileView {
  name: string;
  game: string;
  builderInterface: string;
  useLatest: string;
  isGuest: boolean;
  defaultLocale: string;

  constructor(params: ProfileViewParams) {
    this.name = params.name;
    this.game = params.game;
    this.builderInterface = params.builderInterface;
    this.useLatest = params.useLatest;
    this.isGuest = params.isGuest;
    this.defaultLocale = params.defaultLocale;
  }
}

export type ProfileViewParams = {
  name: string;
  game: string;
  builderInterface: string;
  useLatest: string;
  isGuest: boolean;
  defaultLocale: string;
};
